import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Toaster } from "react-hot-toast";

import Login from "./Components/login";

import DashboardLayout from "./Components/dashboard/DashboardLayout";
import DashboardHome from "./Components/dashboard/dashboard";
import Users from "./Components/dashboard/users";
import PackageRequest from "./Components/dashboard/packagerequest";
import AutoPoolIncome from "./Components/dashboard/autopoolincome";
import ReferralIncome from "./Components/dashboard/referralIncome";
import QrManagement from "./Components/dashboard/qr";
import EditUser from "./Components/dashboard/edituser";
import PackageRequestHistory from "./Components/dashboard/packagerequesthistory";
import WithdrawalRequest from "./Components/dashboard/withdrawalrequest";
import WalletTransfer from "./Components/dashboard/wallettransfer";
import AutoPoolDetails from "./Components/dashboard/autopooldetails";
import AutoPoolList from "./Components/dashboard/autopoollist";
import PrePayAutoPool from "./Components/dashboard/prepaypool";
import EditUserProfile from "./Components/dashboard/edituserprofile";
import AutoPoolPayment from "./Components/dashboard/autopoolpayment";
import SupportIncome from "./Components/dashboard/supportincome";
import AddSupportIncome from "./Components/dashboard/addsupportincome";
import SelfActivationWallet from "./Components/dashboard/selfactivationwallet";
import TransferSelfWallet from "./Components/dashboard/transferselftwallet";
import SelfActivationWalletTransaction from "./Components/dashboard/selfActivationWallettransaction";

/* ================= PROTECTED ROUTE ================= */

const ProtectedRoute = ({ children }) => {
  const storedUser = sessionStorage.getItem("user");
  const accessToken = sessionStorage.getItem("accessToken");

  if (!storedUser || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

/* ================= APP ================= */

export default function App() {
  return (
    <>
      {/* ================= TOAST ================= */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
        }}
      />

      <Routes>
        {/* ================= LOGIN ================= */}

        <Route path="/" element={<Login />} />

        <Route path="/login" element={<Login />} />

        {/* ================= DASHBOARD ================= */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard Home */}
          <Route index element={<DashboardHome />} />

          {/* Users */}
          <Route path="users" element={<Users />} />

          {/* Package Requests */}
          <Route path="package-request" element={<PackageRequest />} />

          <Route
            path="package-request-history"
            element={<PackageRequestHistory />}
          />

          {/* Withdrawal / Payout */}
          <Route path="payout-request" element={<WithdrawalRequest />} />

          {/* Wallet */}
          <Route path="wallet-transfer" element={<WalletTransfer />} />

          {/* Income */}
          <Route path="referral-income" element={<ReferralIncome />} />

          <Route path="autopool-income" element={<AutoPoolIncome />} />
          <Route path="add-admin-support" element={<AddSupportIncome />} />
          <Route path="autopool-payment" element={<AutoPoolPayment />} />
          <Route path="autopool-details/:id" element={<AutoPoolDetails />} />
          <Route path="edit-user-profile/:id" element={<EditUserProfile />} />
          <Route path="autopool-list" element={<AutoPoolList />} />
          <Route path="admin-support" element={<SupportIncome />} />
          <Route
            path="prepay-autopool/:userId"
            element={<PrePayAutoPool />}
          />

          {/* QR */}
          <Route path="qr" element={<QrManagement />} />
          <Route path="selfactivationwallet" element={<SelfActivationWallet />} />
          <Route path="selfactivationwallettransaction" element={<SelfActivationWalletTransaction />} />
          <Route path="transfer-self-wallet" element={<TransferSelfWallet />} />

          {/* Edit User */}
          <Route path="edit-user/:id" element={<EditUser />} />
        </Route>

        {/* ================= FALLBACK ================= */}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}